/**
 * Доля метрики Key Metrics в процентах (занятость, апселлы).
 * Нет базы (0 или нет данных) — процент не показывается (пустая строка),
 * карточка выводит только значение: «0», а не «0 0%».
 */
export function formatKeyMetricPercent(
  value: number | null | undefined,
  base: number | null | undefined,
): string {
  if (
    value === null ||
    value === undefined ||
    base === null ||
    base === undefined ||
    !Number.isFinite(value) ||
    !Number.isFinite(base) ||
    base <= 0
  ) {
    return "";
  }
  return `${Math.min(100, Math.round((value / base) * 100))}%`;
}
